<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { VButton, VIcon, VSection } from '@/modules/shared/components'
import { useAuthStore } from '@/modules/auth/stores/auth-store'
import { useNotificationStore } from '@/modules/shared/stores/notification-store'
import TheLayout from '@/modules/shared/layouts/the-layout.vue'
import MessageList from '../components/MessageList.vue'
import { useMessagingStore } from '../stores/messaging-store'

const router = useRouter()
const authStore = useAuthStore()
const notificationStore = useNotificationStore()
const messagingStore = useMessagingStore()

const skeleton = ref(true)
const isAdmin = computed(() => authStore.is_site_or_group_admin)

onMounted(async () => {
  try {
    await messagingStore.fetchMessages()
  } catch {
    notificationStore.enqueue('error', 'Failed to load messages')
  }
  skeleton.value = false
})

const onDelete = async (id: number) => {
  try {
    await messagingStore.destroyMessage(id)
    notificationStore.enqueue('success', 'Message deleted')
  } catch {
    notificationStore.enqueue('error', 'Failed to delete message')
  }
}

const onView = (id: number) => {
  router.push({ name: 'messaging.show', params: { id } })
}
</script>

<template>
  <TheLayout>
    <VSection label="Messages">
      <template #actions>
        <VButton v-if="isAdmin" :click="() => router.push({ name: 'messaging.new' })" size="md" variant="v-blue">
          <div class="flex items-center space-x-2">
            <VIcon name="Plus" />
            <span>New Message</span>
          </div>
        </VButton>
      </template>

      <MessageList
        :messages="messagingStore.messages"
        :skeleton="skeleton"
        :is-admin="isAdmin"
        @delete="onDelete"
        @view="onView"
      />
    </VSection>
  </TheLayout>
</template>
